import React from 'react';

/**
 * Renders an SVG bunting/thoran illustration with the given triangle colours.
 * thoranColors: array of hex colours for the triangular flags
 * bgColor: background colour of the card
 * height: SVG height in px (default 180)
 */
const ThoranVisual = ({ thoranColors = ['#FF9933'], bgColor = '#FFF3E0', height = 180, label = '' }) => {
  const W = 400;
  const H = height;
  const rope_y = H * 0.3;
  const triW = 50;
  const triH = H * 0.45;
  const gap = 10;
  const totalTri = Math.floor(W / (triW + gap));
  const colors = thoranColors;

  const triangles = [];
  for (let i = 0; i < totalTri; i++) {
    const x1 = i * (triW + gap) + 5;
    const x2 = x1 + triW;
    const xm = x1 + triW / 2;
    const col = colors[i % colors.length];
    const isDark = col === '#FFFFFF' || col === '#FDD835' || col === '#FFD700' || col === '#FFB300';
    triangles.push(
      <g key={i}>
        <polygon
          points={`${x1},${rope_y} ${x2},${rope_y} ${xm},${rope_y + triH}`}
          fill={col}
          stroke={isDark ? '#ccc' : 'rgba(0,0,0,0.08)'}
          strokeWidth="1"
        />
      </g>
    );
  }

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      width="100%"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', background: bgColor }}
    >
      {/* Background */}
      <rect width={W} height={H} fill={bgColor} />

      {/* Decorative dots top */}
      {[...Array(8)].map((_, i) => (
        <circle key={i} cx={i * 55 + 25} cy={rope_y * 0.5} r="3"
          fill={colors[i % colors.length]} opacity="0.4" />
      ))}

      {/* Triangle flags */}
      {triangles}

      {/* Rope */}
      <path
        d={`M0 ${rope_y} Q${W / 4} ${rope_y + 6} ${W / 2} ${rope_y} Q${(3 * W) / 4} ${rope_y - 6} ${W} ${rope_y}`}
        stroke="#6D4C41"
        strokeWidth="2.5"
        fill="none"
      />

      {/* Knots on rope */}
      {[...Array(totalTri)].map((_, i) => {
        const x = i * (triW + gap) + 5 + triW / 2;
        return <circle key={i} cx={x} cy={rope_y} r="3" fill="#5D4037" />;
      })}

      {/* Label */}
      {label && (
        <text
          x={W / 2} y={H - 10}
          textAnchor="middle"
          fontSize="13"
          fontWeight="bold"
          fill="#555"
          fontFamily="Arial, sans-serif"
        >
          {label}
        </text>
      )}
    </svg>
  );
};

export default ThoranVisual;
